export * from './module/activity'
export * from './module/tmuyun'
export * from './module/dev-api'
export * from './module/company'
export * from './module/kb-pgc-user-act'

/**
 *
 * @description 神策埋点
 */
export const sensorsTracker = {

    /**
     *
     * @description 自定义上报
     */
    report(params: {
        /** 上报名 */
        name: string

        /** 上报字段 */
        params: Record<string, any>
    }) {
        console.log('sensors-tracker.report', params.name, params.params)
        window['sensors'].track(params.name, params.params)
    },
}
